import type { FaireProductEntity } from "../../entity_types/product";

export const p_b7vsk67ywt: FaireProductEntity = {
  token: "p_b7vsk67ywt",
  type: "product",
  name: "Doghouse Matches",
  brandToken: "b_b703e67f",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/53c2bc001882284041e7e76967ead7641f3124b6ae0fc6bb218c19dfdbb14c0e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2acafc8e2da7183467bb109bddcb20ea04d29418e4b4ce3ea5e16d364a53f1fb.jpeg",
    "https://cdn.faire.com/fastly/4e9ac8e599f9d4ab4afd60b0a954c122e4f9bf02eaf6ae6396c757c09f4717ba.jpeg",
    "https://cdn.faire.com/fastly/a19998380b406d11eacb410c0f93e408a063d95c787e5105403e923e276f4011.jpeg",
    "https://cdn.faire.com/fastly/ea12432416f3a26f0783c9ed2e104e4b81085a08345ceac95baea743e76a95b7.jpeg",
    "https://cdn.faire.com/fastly/4624adb739afa116d21b73c5d893630376927c0c9564d267e11fddeca6b4a848.jpeg",
    "https://cdn.faire.com/fastly/cae3544cf0c1584b78ddfcc1b8b171a783957083fbeea87222984b9794d19940.jpeg",
    "https://cdn.faire.com/fastly/5edbe15350ac455dbe0c813edde1943f4da3fb2390ce1aa6de28a21bfd17300c.jpeg",
    "https://cdn.faire.com/fastly/a832a1290076df37d9bb7fb91591920784a600b45d187106a0c23813a051a2af.jpeg",
    "https://cdn.faire.com/fastly/60899f0fabc0abf25f18ffbdd3b3d675f7706195d0ee64647a9b0753d3cf8f5e.jpeg",
  ],
  priceDollars: 8.32,
  description:
    '\nIf you\'re gonna be in the doghouse, we hope it\'s at least a really cute one like this! \n\nThese matches are in a box shaped like an adorable little doghouse and features the cutest tiny furry friends all over. The amazing art for these was done by Claire Shadomy, who can be found here!\n\nThis matchbox measures approx. 1.75" x 2.25" x 2.5"\n\nComes with approximately 70 matches. The striker is on the side of the box. \n\nThis design is the sole property of A Shop of Things and cannot be reproduced or copied for any reason without permission beforehand. ©\n\nLighters/matches can NOT be shipped internationally.\n',
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:13.456Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
